import { render } from "./gobackbutton.vue?vue&type=template&id=349121b6"
import script from "./gobackbutton.vue?vue&type=script&lang=js"
export * from "./gobackbutton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__